import React from 'react';
import classnames from 'classnames';
import {CircledPlusIcon} from '@components/icon/CircledPlusIcon';
import './TriggerIconButton.styl';

export default class TriggerIconButton extends React.Component {
  render() {
    const {active, label, className, icon} = this.props;
    const Icon = icon || <CircledPlusIcon tooltip="Select" />;
    return (
      <div
        className={classnames('trigger-icon-button plus-button', className, {
          active,
        })}
        onClick={this.props.onClick}>
        <div>{!active && Icon}</div>
        <label>{label}</label>
        {this.props.children}
      </div>
    );
  }
}
